/**
 * Single source of truth for the CMS content sections (ContentSection rows).
 * Imported by the public routes that render them AND by /admin/content, so the
 * beheer overview and the pages cannot drift apart: every section listed here
 * must be rendered somewhere, and every rendered section must be listed here.
 */

export const HOME_SECTION_IDS = {
	OVERVIEW: 'home-overview',
} as const

export const OVER_SECTION_IDS = {
	INTRO: 'over-intro',
	AMSTERDAM_NOTE: 'over-amsterdam-note',
	INSPIRATION_INTRO: 'over-inspiration-intro',
	BALANCE_NOTE: 'over-balance-note',
	THEATER_NOTE: 'over-theater-note',
	WIND_NOTE: 'over-wind-note',
	NARCISSUS_NOTE: 'over-narcissus-note',
	OPDRACHTEN_INTRO: 'over-opdrachten-intro',
} as const

/** Registry for the /admin/content overview. */
export const CONTENT_SECTIONS = {
	HOME: {
		id: HOME_SECTION_IDS.OVERVIEW,
		name: 'Homepage - Overview',
		description: 'Main introduction text on the homepage',
	},
	ABOUT_INTRO: {
		id: OVER_SECTION_IDS.INTRO,
		name: 'About - Introduction',
		description: 'Introduction paragraph on the about page',
	},
	ABOUT_AMSTERDAM: {
		id: OVER_SECTION_IDS.AMSTERDAM_NOTE,
		name: 'About - Amsterdam Note',
		description: 'Note about Amsterdam artwork',
	},
	ABOUT_INSPIRATION_INTRO: {
		id: OVER_SECTION_IDS.INSPIRATION_INTRO,
		name: 'About - Inspiration Introduction',
		description: 'Introduction to inspiration section',
	},
	ABOUT_BALANCE: {
		id: OVER_SECTION_IDS.BALANCE_NOTE,
		name: 'About - Balance Note',
		description: 'Note about balance artworks',
	},
	ABOUT_THEATER: {
		id: OVER_SECTION_IDS.THEATER_NOTE,
		name: 'About - Theater on Water Note',
		description: 'Description of Theater on Water artwork',
	},
	ABOUT_WIND: {
		id: OVER_SECTION_IDS.WIND_NOTE,
		name: 'About - Wind Note',
		description: 'Description of "Wie wind zaait..." artwork',
	},
	ABOUT_NARCISSUS: {
		id: OVER_SECTION_IDS.NARCISSUS_NOTE,
		name: 'About - Narcissus Note',
		description: 'Description of Narcissus artwork',
	},
	ABOUT_OPDRACHTEN: {
		id: OVER_SECTION_IDS.OPDRACHTEN_INTRO,
		name: 'About - Commissions Introduction',
		description: 'Introduction to commissions section',
	},
} as const
